<template>
  <div>
    <div
      @click="handlerClick"
      class="my-moral fb fb-col fb-cross-center fb-main-center"
    >
      <span class="iconfont c-FFFFFF font-32 mb-4">&#xe6ab;</span>
      <p class="c-FFFFFF font-22">{{ text }}</p>
    </div>
    <common-action-sheet
      :list="actionList"
      :open="showAction"
      @cancel="close"
      @choose="choose"
    >
    </common-action-sheet>
  </div>
</template>

<script>
import { mcToast } from '@/utils/mcSdkUtils'
import commonActionSheet from './commonActionSheet'
import { timeFormat } from '@/utils/comUtils'

export default {
  components: { commonActionSheet },
  props: {
    type: {
      type: Number,
      default: 1
    },
    text: {
      type: String,
      default: '我要考评'
    }
  },
  data() {
    return {
      showAction: false,
      actionList: [
        {
          id: 2,
          name: '个人评比'
        },
        {
          id: 1,
          name: '班级评比'
        }
      ]
    }
  },
  computed: {},
  watch: {},
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  activated() {},
  deactivated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    handlerClick() {
      const {
        termStartDimDay,
        termEndDimDay
      } = this.$store.getters.semesterSetting
      const _date = timeFormat(new Date(), 'YYYYMMDD')
      if (_date < termStartDimDay || _date > termEndDimDay) {
        return mcToast({ msg: '当前日期不在学年学期范围内' })
      }
      if (this.type === 1) {
        this.$router.push({
          path: '/classcard/search',
          query: { type: 0 }
        })
      } else if (this.type === 2) {
        this.showAction = true
      }
    },
    choose(item) {
      let _path = '/classcard/search'
      let _query = {
        type: 1,
        typeId: item.id
      }
      if (item.id === 1) {
        _path = '/classcard/selectclass'
        _query.link = '/classcard/evaluation'
      }
      this.$router.push({
        path: _path,
        query: _query
      })
    },
    close(show) {
      this.showAction = show
    }
  }
}
</script>

<style lang="scss" scoped>
.my-moral {
  position: fixed;
  right: 16px;
  bottom: 100px;
  border-radius: 50%;
  width: 60px;
  height: 60px;
  background: #006afe;
  box-shadow: 0px 3px 15px -1px rgba(0, 137, 255, 0.75);
}
</style>
